import { Box, Typography } from "@mui/material";

export const Loading2 = ({ message = "Cargando", showText = false }) => {
  return (
    <div className="flex justify-center items-center">
      {showText ? (
        <Box sx={{ zIndex: "9999999999", color: "#ffffff" }}>
          <Typography variant="h5" className="loading pt-[150px]">
            {message}
          </Typography>
        </Box>
      ) : null}
    </div>
  );
};
